export const frontofficeDevToolsPlugins = [];
